module.exports = __webpack_public_path__ + "img/touchFullscreen.eb26cd7e.png";